<template>
  <div>
    <MapInfo :show="showMarkerInfo" :marker="activeMarker" @closed="clearLocationInfo()" />

    <!-- <center>Map not available at the moment</center> -->
    <gmap-map :center="center" :zoom="6.4" style="width: 100%; height: 400px">
      <gmap-marker
        :key="index"
        v-for="(marker, index) in markers"
        :position="{ lat: marker.latitude, lng: marker.longitude }"
        :clickable="true"
        @click="showLocationInfo(marker)"
        @mouseover="showLocationInfo(marker)"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
import '@/plugins/google-maps'
import MapInfo from '@/components/Map/MapInfo.vue'

export default {
  name: 'Maps',
  components: {
    MapInfo
	},
	props: ['markers', 'aids', 'events'],
  data () {
    return {
      isLoading: false,
      center: { lat: 9.9155163, lng: 8.8032966 },
			showMarkerInfo: false,
			activeMarker: {}
    }
	},
	methods: {
		markerClick (marker) {
			this.$router.push('/locations?s=' + marker.name)
		},
		showLocationInfo (marker) {
			this.activeMarker = marker
			this.showMarkerInfo = true
		},
		clearLocationInfo () {
			this.showMarkerInfo = false
			this.activeMarker = {}
		}
	}
}
</script>
